import axios from "axios";
import store from "@/store";
import {builderBaseUrl} from "@/main";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {queryBuilder, filters} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/QueryFilter'

let filtersCopy = JSON.parse(JSON.stringify(filters))

export default {
    namespaced: true,
    state: {
        projects: [],
        project: null,
        ...filtersCopy,
    },
    mutations: {
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
    },
    actions: {
        deleteDnsRecord({commit, state}, form) {
            const user_id = store.getters['User/getUserId']
            let req = axios.delete(`${builderBaseUrl}/dns-manager/${form.project_id}/user/${user_id}/delete/meta/${form.item_id}`)
            return req
        },
        buildDnsRecord({commit, state}, form) {
            const user_id = store.getters['User/getUserId']
            let req = axios.get(`${builderBaseUrl}/dns-manager/${form.project_id}/user/${user_id}/build`)
            return req
        },
        createDnsRecord({commit, state}, form) {
            const user_id = store.getters['User/getUserId']
            let req = axios.post(`${builderBaseUrl}/dns-manager/${form.project_id}/user/${user_id}/create`, form)
            return req
        },
        updateDnsRecord({commit, state}, form) {
            const user_id = store.getters['User/getUserId']
            let req = axios.post(`${builderBaseUrl}/dns-manager/${form.project_id}/user/${user_id}/update/meta/${form.item_id}`, form)
            return req
        },
    },
    getters: {},
}